import { datadogLogs } from '@datadog/browser-logs';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { conditionalString } from '@strata/helper-functions';
import { ErrorToast } from '@strata/react-toast-message';
import { type ErrorInfo } from 'react';

interface FMHError {
    data?: { detail?: string };
}

interface ParsedError {
    message?: string;
    details?: string;
}

export const handleError = (
    message: string,
    error?: FetchBaseQueryError | Error | { error: Error; info: ErrorInfo },
) => {
    // Parse and format the error string
    let parsedError: ParsedError | undefined;
    try {
        const errorDetail = (
            JSON.parse((error as Error)?.message) as { detail?: ParsedError | string } | undefined
        )?.detail;
        parsedError = typeof errorDetail === 'object' ? errorDetail : { message: errorDetail };
    } catch {
        parsedError = { message: (error as Error)?.message };
    } finally {
        const errorMessage = parsedError?.message ?? message;

        let errorMessageDetails = (error as FMHError)?.data?.detail ?? parsedError?.details;
        errorMessageDetails = conditionalString(!!errorMessageDetails, ` ${errorMessageDetails}`);
        const displayMessage = `${errorMessage}${errorMessageDetails}`;

        ErrorToast({ message: displayMessage });
        datadogLogs.logger.error(displayMessage, { error });
        // eslint-disable-next-line no-console
        console.error(displayMessage, error);
    }
};

export const handleRTKQueryError = (message: string) => (error: FetchBaseQueryError) => {
    handleError(message, error);
    return error;
};
